import { Pipe, PipeTransform } from '@angular/core';
import { Customer } from '../../customer/interfaces/customer';
import { CustomerType } from '../../customer/interfaces/customer-type';
import { PrivateCustomer } from '../../private-customer/interface/private-customer';

/**
 * Formatiert die übergebene Nummer in einen lokalisierten String zur Wiedergabe im Frontend
 */
@Pipe({ name: 'displayCustomerType' })
export class DisplayCustomerTypePipe implements PipeTransform {
  transform(customer: Customer|PrivateCustomer): string {
    if (customer.Type === CustomerType.INSURED_CUSTOMER) {
      return 'Kassenkunde';
    }

    if (customer.Type === CustomerType.PRIVATE_CUSTOMER) {
      return 'Sonstiger Kunde';
    }
    return 'nicht definiert';
  }
}